import { useState, useEffect } from "react";
import api from "../../services/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faSquarePlus, faSquareMinus } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import EditModal from "../ui/EditModal.js";
import { normalizar } from "../../common/stringNormalizer.js";

const AddEstado = () => {
  const [filtroEstado, setFiltroEstado] = useState("activas");
  const [Nombre, setNombre] = useState("");
  const [Estado, setEstado] = useState([]);
  const [ColorAsociado, setColorAsociado] = useState("#FFFFFF");
  const [selectedEstado, setSelectedEstado] = useState(null);

  useEffect(() => {
    getEstados();
  }, []);

const filtrarEstados = () => {
  if (filtroEstado === "activas") return Estado.filter(e => e.estado === 1);
  if (filtroEstado === "inactivas") return Estado.filter(e => e.estado === 0);
  return Estado;
};



  const editFields = [
    { name: "Nombre", label: "Tipo Estado Persona", type: "text", required: true },
    { name: "ColorAsociado", label: "Color del estado", type: "color", required: true }
  ];

  const getEstados = async () => {
    const response = await api.get(`/estados`);
    setEstado(response.data);
  };

  const createEstado = async (e) => {
    e.preventDefault();

    // Validar duplicado
    const existe = Estado.some(
      (estado) => normalizar(estado.Nombre) === normalizar(Nombre)
    );

    if (existe) {
      Swal.fire({
        icon: "warning",
        title: "Duplicado",
        text: "Ya existe un estado con ese nombre.",
        confirmButtonColor: "#3085d6"
      });
      return;
    }

    try {
      await api.post(`/estados`, {
        Nombre,
        ColorAsociado,
      });
      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "El estado fue guardado exitosamente.",
        timer: 1500,
        showConfirmButton: false,
      });
      setNombre("");
      setColorAsociado("#FFFFFF");
      getEstados();
    } catch (error) {
      console.log("Error creando estado:", error);
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        title: "Ocurrió un error al crear el estado.",
      });
    }
  };

  const handleEditEstado = async (values) => {
    try {
      await api.patch(`/estados/cambiarEstado/${values.IdEstado}`, { Nombre: values.Nombre, ColorAsociado: values.ColorAsociado });
      Swal.fire({
        icon: "success",
        title: "Estado actualizado",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Error al actualizar:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al actualizar el estado.",
      });
    }
    setSelectedEstado(null);
    getEstados();
  };
const cambiarEstadoEstado = async (IdEstado) => {
  try {
    await api.patch(`/estados/cambiarEstadoEstado/${IdEstado}`);
    getEstados();
    Swal.fire({
      icon: "success",
      title: "Estado actualizado",
      text: "El estado fue cambiado exitosamente.",
      timer: 1500,
      showConfirmButton: false
    });
  } catch (error) {
    if (error.response?.status === 409 && error.response?.data?.code === "ESTADO_ASOCIADO") {
      Swal.fire({
        icon: "warning",
        title: "No se puede desactivar",
        text: error.response.data.mensaje,
        confirmButtonColor: "#3085d6"
      });
    } else {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al cambiar el estado.",
      });
    }
  }
};

  const Color = ({ color }) => (
    <div style={{ height: '25px', width: '25px', backgroundColor: color, borderRadius: 50, display: 'inline-block' }} />
  );

  const columnas = [
    {
      name: 'Nombre',
      selector: row => row.Nombre,
      sortable: true,
    },
    {
      name: 'Color Asociado',
      cell: (row) => <Color color={row.ColorAsociado} />
    },
    {
      name: "Editar",
      cell: row => (
        <button
          className="button is-small is-info"
          onClick={() => setSelectedEstado(row)}
        >
          <FontAwesomeIcon icon={faPencil} />
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true
    },
    {
      cell: (row) =>
        row.estado === 1 ?
          <FontAwesomeIcon icon={faSquarePlus} style={{ color: "#37ff00", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstadoEstado(row.IdEstado)} />
          :
          <FontAwesomeIcon icon={faSquareMinus} style={{ color: "#ff0000", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstadoEstado(row.IdEstado)} />,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

const paginationOptionsES = {
  rowsPerPageText: 'Filas por página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};

  return (
    <div className="columns mt-5 is-centered">
      <div className="column is-half">
        <div className="notification is-primary">
          <strong>Ingresa el estado de la persona</strong>
        </div>
        <form onSubmit={createEstado}>
          <div className="field">
            <label className="label required">Tipo Estado Persona</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={Nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Nombre"
                required
              />
              <input
                type="color"
                id="head"
                name="head"
                value={ColorAsociado}
                onChange={(e) => setColorAsociado(e.target.value)}
              />
              <label htmlFor="head">&#60;--Color del estado</label>
            </div>
          </div>
          <div className="field">
            <button type="submit" className="button is-success">
              Guardar
            </button>
          </div>
        </form>
        <div style={{ width: '700px', border: '1px solid gray', borderRadius: '8px' }}>
          <div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
  {["todas", "activas", "inactivas"].map((estado) => (
    <button
      key={estado}
      onClick={() => setFiltroEstado(estado)}
      type="button"
      style={{
        padding: "6px 16px",
        border: "none",
        borderRadius: "20px",
        backgroundColor: filtroEstado === estado ? "#d1f5d3" : "#f0f2f5",
        color: filtroEstado === estado ? "#075e54" : "#333",
        fontWeight: filtroEstado === estado ? "bold" : "normal",
        boxShadow:
          filtroEstado === estado
            ? "inset 0 0 0 1px #1ebea5"
            : "inset 0 0 0 1px #ccc",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        fontSize: "0.9rem",
      }}
    >
      {estado.charAt(0).toUpperCase() + estado.slice(1)}
    </button>
  ))}
</div>
          <DataTable
            pagination
              paginationComponentOptions={paginationOptionsES}
            columns={columnas}
           data={filtrarEstados()}
          />
        </div>
        {selectedEstado && (
          <EditModal
            fields={editFields}
            initialValues={selectedEstado}
            onSubmit={handleEditEstado}
            title="Editar Estado"
            onClose={() => setSelectedEstado(null)}
          />
        )}
      </div>
    </div>
  );
};

export default AddEstado;
